import React, { useEffect, useState } from 'react';
import { ArrowDown } from 'lucide-react';
import { useLanguage } from "@/contexts/LanguageContext";

export const VideoMaskHero = ({ 
  videoUrl = "/assets/showreel_2024.mp4",
  watermarkUrl = "/assets/emblem.svg"
}) => {
  const [scrolled, setScrolled] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  return (
    <div className="relative h-screen w-full overflow-hidden">
      
      {/* PARALLAX HERO SETUP */}
      <div className="fixed inset-0 w-full h-full z-0 bg-concrete-900">
          <div className="absolute inset-0 bg-concrete-900/30 z-10 mix-blend-multiply"></div> 
          <video 
              className="w-full h-full object-cover"
              autoPlay 
              muted 
              loop 
              playsInline
              poster="/assets/twilight.jpg"
          >
              <source src={videoUrl} type="video/mp4" />
          </video>

          {/* Scroll Indicator - Fades out */}
          <div className={`absolute bottom-10 left-0 right-0 z-20 flex flex-col items-center animate-bounce transition-opacity duration-500 ${
              scrolled ? 'opacity-0' : 'opacity-100'
          }`}>
             <span className="text-white/60 text-xs tracking-[0.3em] mb-2 font-mono uppercase">{t('scroll_explore')}</span>
             <ArrowDown className="text-white/80" />
          </div>
      </div>

    </div>
  );
};
